import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DemandComponent } from './components/demand/demand.component';
import { TimeseriesComponent } from './components/timeseries/timeseries.component';

const routes: Routes = [
  { path: '', redirectTo: 'null', pathMatch: 'full' },
  { path: 'demand', component: DemandComponent },
  { path: 'timeseries', component: TimeseriesComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
